import { useContext, useEffect, useState } from "react";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { 
    CustomContainer, ScreenTitle, FlexRow, Circle, AppSpan, 
    AbsoluteContainer, GridContainer, FlexColumn
} from "src/style";
import { IoIosCheckmark } from "react-icons/io";
import { IUserCreationStages } from "src/model";

export const NewUserLayout: React.FC<any> = ({currentScreen, children}) => {
    const {info: {userCreationProcess}} = useContext(AppInfoContext)
    const [process, setProcess] = useState<IUserCreationStages>(userCreationProcess)

    useEffect(() => {
        setProcess(userCreationProcess)
    }, [userCreationProcess])

    return (
        <FlexRow 
            alignItems="flex-start" padding='3'
            topPadding="4" height="100" hUnit="%"
        >
            {/* <FixedContainer 
                top="7.5" left="30"
                className="new-user-process-flow-wrapper"
            > */}
                <CustomContainer 
                    width="35"
                    height="90" hUnit="%"
                    className='new-user-process-flow'
                >
                    <ScreenTitle 
                        textSize="2" color="#111111" 
                        fontWeight="600" bottomMargin="4"
                    >
                        Add New User
                    </ScreenTitle>
                    <CustomContainer>
                        <FlexRow gap="1.5" bottomMargin='0.5'>
                            <Circle 
                                size="2.4" 
                                borderColor={process?.userBasics ? '#27AE60' : currentScreen === 'user-basics' ? "#1D1D1D" : '#ABABAB'}
                                bgColor={process?.userBasics ? '#27AE60' : 'transparent'}
                            >
                                <IoIosCheckmark 
                                    fontSize='1.8rem' 
                                    color={process?.userBasics ? '#ffffff' : currentScreen === 'user-basics' ? "#1D1D1D" : '#ABABAB'}
                                />
                            </Circle>
                            <AppSpan 
                                textSize="1.6" 
                                color={(currentScreen === 'user-basics' && !process?.userBasics) ? '#111111' : '#ABABAB'}
                            >
                                User Basics
                            </AppSpan>
                        </FlexRow>
                        <CustomContainer 
                            height="3.6" 
                            width="0.05" 
                            leftMargin="1.3"
                            bgColor="#ABABAB" 
                            bottomMargin='0.5'
                        />
                        <FlexRow gap="1.5" bottomMargin='0.5'>
                            <Circle 
                                size="2.4" 
                                borderColor={process?.userRole ? '#27AE60' : currentScreen === 'user-role' ? "#1D1D1D" : '#ABABAB'}
                                bgColor={process?.userRole ? '#27AE60' : 'transparent'}
                            >
                                <IoIosCheckmark 
                                    fontSize='1.8rem' 
                                    color={process?.userRole ? '#ffffff' : currentScreen === 'user-role' ? "#1D1D1D" : '#ABABAB'}
                                />
                            </Circle>
                            <AppSpan 
                                textSize="1.6" 
                                color={(currentScreen === 'user-role' && !process?.userRole) ? '#111111' : '#ABABAB'}
                            >
                                User Role
                            </AppSpan>
                        </FlexRow>
                        <CustomContainer 
                            height="3.6" 
                            width="0.05" 
                            leftMargin="1.3"
                            bgColor="#ABABAB" 
                            bottomMargin='0.5'
                        />
                        <FlexRow gap="1.5">
                            <Circle 
                                size="2.4" 
                                borderColor={process?.setupSummary ? '#27AE60' : currentScreen === 'setup-summary' ? "#1D1D1D" : '#ABABAB'}
                                bgColor={process?.setupSummary ? '#27AE60' : 'transparent'}
                            >
                                <IoIosCheckmark 
                                    fontSize='1.8rem' 
                                    color={process?.setupSummary ? '#ffffff' : currentScreen === 'setup-summary' ? "#1D1D1D" : '#ABABAB'}
                                />
                            </Circle>
                            <AppSpan 
                                textSize="1.6" 
                                color={(currentScreen === 'setup-summary' && !process?.setupSummary) ? '#111111' : '#ABABAB'}
                            >
                                Finish Setup
                            </AppSpan>
                        </FlexRow>
                    </CustomContainer>
                </CustomContainer>
            {/* </FixedContainer> */}

            <CustomContainer
                leftMargin="5"
                rightMargin="5"
                width="49.9"
                className="new-user-content"
            >
                <CustomContainer
                    bottomMargin='3'
                    className='new-user-process-flow-mobile'
                >
                    <ScreenTitle 
                        textSize="2" color="#111111" 
                        fontWeight="600" bottomMargin="4"
                    >
                        Add New User
                    </ScreenTitle>
                    <FlexRow alignItems='flex-start' justifyContent='space-between'>
                        <AbsoluteContainer 
                            width='100' sizeUnit='%' top='1.2' zIndex='1'
                        >
                            <GridContainer>
                                <CustomContainer 
                                    height="0.05"
                                    bgColor="#ABABAB" 
                                    width='82' sizeUnit='%'
                                />
                            </GridContainer>
                        </AbsoluteContainer>
                        <FlexColumn 
                            width='auto' sizeUnit='' 
                            justifyContent='center'
                            style={{zIndex: '2'}}
                        >
                            <Circle 
                                size="2.4" bottomMargin='1'
                                borderColor={process?.userBasics ? '#27AE60' : currentScreen === 'user-basics' ? "#1D1D1D" : '#ABABAB'}
                                bgColor={process?.userBasics ? '#27AE60' : '#ffffff'}
                            >
                                <IoIosCheckmark 
                                    fontSize='1.8rem' 
                                    color={process?.userBasics ? '#ffffff' : currentScreen === 'user-basics' ? "#1D1D1D" : '#ABABAB'}
                                />
                            </Circle>
                            <AppSpan 
                                textSize="1.6" 
                                color={(currentScreen === 'user-basics' && !process?.userBasics) ? '#111111' : '#ABABAB'}
                            >
                                User Basics
                            </AppSpan>
                        </FlexColumn>
                        <FlexColumn 
                            width='auto' sizeUnit='' 
                            justifyContent='center'
                            style={{zIndex: '2'}}
                        >
                            <Circle 
                                size="2.4" bottomMargin='1'
                                borderColor={process?.userRole ? '#27AE60' : currentScreen === 'user-role' ? "#1D1D1D" : '#ABABAB'}
                                bgColor={process?.userRole ? '#27AE60' : '#ffffff'}
                            >
                                <IoIosCheckmark 
                                    fontSize='1.8rem' 
                                    color={process?.userRole ? '#ffffff' : currentScreen === 'user-role' ? "#1D1D1D" : '#ABABAB'}
                                />
                            </Circle>
                            <AppSpan 
                                textSize="1.6" 
                                color={(currentScreen === 'user-role' && !process?.userRole) ? '#111111' : '#ABABAB'}
                            >
                                User Role
                            </AppSpan>
                        </FlexColumn>
                        <FlexColumn 
                            width='auto' sizeUnit='' 
                            justifyContent='center'
                            style={{zIndex: '2'}}
                        >
                            <Circle 
                                size="2.4" bottomMargin='1'
                                borderColor={process?.setupSummary ? '#27AE60' : currentScreen === 'setup-summary' ? "#1D1D1D" : '#ABABAB'}
                                bgColor={process?.setupSummary ? '#27AE60' : '#ffffff'}
                            >
                                <IoIosCheckmark 
                                    fontSize='1.8rem' 
                                    color={process?.setupSummary ? '#ffffff' : currentScreen === 'setup-summary' ? "#1D1D1D" : '#ABABAB'}
                                />
                            </Circle>
                            <AppSpan 
                                textSize="1.6" 
                                color={(currentScreen === 'setup-summary' && !process?.setupSummary) ? '#111111' : '#ABABAB'}
                            >
                                Finish Setup
                            </AppSpan>
                        </FlexColumn>
                    </FlexRow>
                </CustomContainer>

                {children}
            </CustomContainer>
        </FlexRow>
    )
}